import { Moment } from 'moment';

const formatTime = (seconds: number): string => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.round(seconds % 60);

  const hourPart = h;

  let minutePart;
  if (m > 9) {
    minutePart = m;
  } else {
    minutePart = h ? `0${m}` : m || '0';
  }

  const secondePart = s > 9 ? s : `0${s}`;

  return [hourPart, minutePart, secondePart].filter(Boolean).join(':');
};

const getTime = (date: Moment) => {
  const hours = date.hours();
  const minutes = date.minutes();

  const formattedHours = `${hours}`.length === 1 ? `0${hours}` : hours;
  const formattedMinutes = `${minutes}`.length === 1 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes}`;
};

const getTehranDateDetails = () => {
  const tehranTime = new Date().toLocaleString('af-ZA', { timeZone: 'Asia/Tehran' });

  const spTehranTime = tehranTime.split(' ');
  const date = spTehranTime[0].split('-');
  const clock = spTehranTime[1].split(':');

  return {
    year: date[0],
    month: date[1],
    day: date[2],

    hour: Number(clock[0]),
    minute: Number(clock[1]),
    seconds: Number(clock[2]),

    dateTime: tehranTime,
  };
};

const isNowInRange = (startTime: string, endTime: string) => {
  let safeEndTime = endTime;
  if (endTime === '00:00') safeEndTime = '23:59';

  const getMinutes = (str: string) => {
    const time = str.split(':');
    return Number(time[0]) * 60 + Number(time[1]);
  };

  const getMinutesNow = () => {
    const timeNow = getTehranDateDetails();
    return timeNow.hour * 60 + timeNow.minute;
  };

  const now = getMinutesNow();
  const start = getMinutes(startTime);
  const end = getMinutes(safeEndTime);

  return start < now && now < end;
};

function isUTCStringBetweenHours({
  utcString,
  startHour = '',
  endHour = '',
}: {
  utcString: Date;
  startHour: string | undefined;
  endHour: string | undefined;
}): boolean {
  const targetTime = utcString;
  const start = new Date(`${targetTime.toDateString()} ${startHour}`);
  const end = new Date(`${targetTime.toDateString()} ${endHour}`);

  return targetTime >= start && targetTime <= end;
}

const timeUtil = { formatTime, getTime, isNowInRange, getTehranDateDetails, isUTCStringBetweenHours };

export default timeUtil;
